import { useContext } from 'react';

import { SelectChangeEvent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { observer } from 'mobx-react-lite';
import { lookupsStoreCtx } from 'src/stores/lookups';
import { ItemType } from 'src/types';
import { isPending } from 'src/utils/common';

interface ActivityStatusEditorProps {
  id: number | string;
  value: ItemType;
  field: string;
}

export const ActivityStatusEditor = observer(
  ({ id, value, field }: ActivityStatusEditorProps) => {
    const apiRef = useGridApiContext();
    const { activitiesStatus, activitiesStatusLookupReq } =
      useContext(lookupsStoreCtx);

    const changeCellHandler = (fieldName: string, cellValue: ItemType) => {
      return apiRef.current.setEditCellValue({
        id,
        field: fieldName,
        value: cellValue,
      });
    };

    const handleChange = async (_event: SelectChangeEvent, child?: any) => {
      const newStatus = activitiesStatus.find(
        ({ id }) => id === child?.props.value,
      );
      if (!newStatus) {
        // eslint-disable-next-line no-console
        console.warn('Status not found');
        return;
      }
      await changeCellHandler(field, newStatus);
    };

    return (
      <Select
        value={String(value?.id || '')}
        fullWidth
        onChange={handleChange}
        endAdornment={
          isPending(activitiesStatusLookupReq) ? (
            <CircularProgress color="inherit" size={20} />
          ) : null
        }>
        {activitiesStatus?.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    );
  },
);

export default ActivityStatusEditor;
